import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import { formatCredentialType } from '../services/api';
import Header from './Header';

const QRRegistrationPage = () => {
  const navigate = useNavigate();
  const [registrationData, setRegistrationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [autoRedirect, setAutoRedirect] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [copiedLinks, setCopiedLinks] = useState({});

  useEffect(() => {
    // Detect mobile device
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      setIsMobile(isMobileDevice);
    };
    checkMobile();

    // Load registration data from localStorage
    const data = localStorage.getItem('registrationData');
    if (data) {
      try {
        const parsed = JSON.parse(data);
        setRegistrationData(parsed);
        setLoading(false);
      } catch (error) {
        console.error('Failed to parse registration data:', error);
        setLoading(false);
      }
    } else {
      navigate('/register');
    }
  }, [navigate]);

  useEffect(() => {
    if (autoRedirect) {
      navigate('/login');
    }
  }, [autoRedirect, navigate]);


  const detectPlatform = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(ua)) return 'android';
    if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
    return 'ios';
  };

  const handleOpenMobileApp = (offerUri) => {
    if (!offerUri) return alert('No credential offer available for this credential.');
    
    // Try to open the app directly
    window.location.href = offerUri;
  };

  const handleCopyLink = async (offerUri, credentialIndex) => {
    try {
      await navigator.clipboard.writeText(offerUri);
      setCopiedLinks(prev => ({ ...prev, [credentialIndex]: true }));
      setTimeout(() => {
        setCopiedLinks(prev => ({ ...prev, [credentialIndex]: false }));
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = offerUri;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopiedLinks(prev => ({ ...prev, [credentialIndex]: true }));
      setTimeout(() => {
        setCopiedLinks(prev => ({ ...prev, [credentialIndex]: false }));
      }, 2000);
    }
  };

  const scrollToDownloadSection = () => {
    const downloadSection = document.getElementById('download-section');
    if (downloadSection) {
      downloadSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div>Loading credentials...</div>
      </div>
    );
  }

  if (!registrationData || !registrationData.credentials) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <p>No credentials available</p>
          <Link to="/register" className="btn btn-primary">Go to Registration</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Header
        showNavigation={false}
        showAuthButtons={false}
        backgroundColor="#FFF9EB"
        showSubtitle={true}
        subtitle="Secure your login credential for faster login next time"
      />

      <main style={{ padding: '60px 0' }}>
        <div className="container">
          {registrationData.pepCheck && (
            <div style={{ maxWidth: 500, margin: '0 auto', marginBottom: '20px' }}>
              <strong>PEP Status:</strong>
              <span
                style={{
                  marginLeft: '10px',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  backgroundColor: registrationData.pepCheck.status === 'NO_MATCH' ? '#4CAF50' : '#ff9800',
                  color: 'white',
                  fontSize: '12px',
                }}
              >
                {registrationData.pepCheck.status === 'NO_MATCH' ? '✓ Clear' : '⚠ Match'}
              </span>
            </div>
          )}

          <div className="card">
            <h2
              style={{
                marginBottom: '30px',
                color: '#333',
                textAlign: 'center',
              }}
            >
               {isMobile
                 ? 'Tap these buttons to open your wallet app and receive your credentials'
                 : 'Scan these QR codes with your EUDI Wallet to receive your credentials'}
            </h2>

            <p
              style={{
                textAlign: 'center',
                color: '#666',
                marginBottom: '30px',
              }}
            >
               {isMobile && (
                 <span style={{ display: 'block', marginTop: '10px', fontSize: '14px' }}>
                   Tap each button below to open your wallet app and receive the credential
                 </span>
               )}
            </p>

            {/* Don't have a wallet link - Mobile Only */}
            {isMobile && (
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <button
                  onClick={scrollToDownloadSection}
                  style={{
                    backgroundColor: 'transparent',
                    color: '#6c757d',
                    border: 'none',
                    fontSize: '12px',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    padding: '4px 8px'
                  }}
                >
                  Don't have a wallet? Download one here
                </button>
              </div>
            )}


            {/* Credentials Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '30px',
                marginBottom: '30px',
              }}
            >
              {registrationData.credentials.map((credential, index) => (
                <div
                  key={index}
                  style={{
                    textAlign: 'center',
                    padding: '20px',
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                  }}
                >
                  {/* <h3
                    style={{
                      color: '#2196F3',
                      marginBottom: '15px',
                    }}
                  >
                    {formatCredentialType(credential.type)}
                  </h3> */}

                  <div
                    style={{
                      padding: '20px',
                      backgroundColor: '#f9f9f9',
                      border: '2px solid #ddd',
                      borderRadius: '12px',
                      display: 'inline-block',
                      marginBottom: '15px',
                      minWidth: 200,
                      minHeight: isMobile ? 60 : 200,
                    }}
                  >
                     {isMobile ? (
                       credential.offer_uri ? (
                         <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
                           <button
                             onClick={() => handleOpenMobileApp(credential.offer_uri)}
                             style={{
                               width: '200px',
                               height: '60px',
                               backgroundColor: '#2196F3',
                               color: 'white',
                               border: 'none',
                               borderRadius: '8px',
                               fontSize: '16px',
                               fontWeight: 'bold',
                               cursor: 'pointer',
                               display: 'flex',
                               alignItems: 'center',
                               justifyContent: 'center',
                               gap: '8px',
                               boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                               transition: 'background-color 0.2s',
                             }}
                             onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1976D2')}
                             onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#2196F3')}
                           >
                             📱 Open in Wallet
                           </button>
                           
                           {/* Copy Link Button for iOS only */}
                           {detectPlatform() === 'ios' && (
                             <button
                               onClick={() => handleCopyLink(credential.offer_uri, index)}
                               style={{
                                 width: '200px',
                                 height: '40px',
                                 backgroundColor: '#f8f9fa',
                                 color: '#6c757d',
                                 border: '1px solid #dee2e6',
                                 borderRadius: '6px',
                                 fontSize: '14px',
                                 fontWeight: '500',
                                 cursor: 'pointer',
                                 display: 'flex',
                                 alignItems: 'center',
                                 justifyContent: 'center',
                                 gap: '6px',
                                 transition: 'all 0.2s',
                               }}
                               onMouseOver={(e) => {
                                 e.currentTarget.style.backgroundColor = '#e9ecef';
                                 e.currentTarget.style.borderColor = '#adb5bd';
                               }}
                               onMouseOut={(e) => {
                                 e.currentTarget.style.backgroundColor = '#f8f9fa';
                                 e.currentTarget.style.borderColor = '#dee2e6';
                               }}
                             >
                               {copiedLinks[index] ? '✓ Copied!' : '📋 Copy Link'}
                             </button>
                           )}
                         </div>
                       ) : (
                         <div
                           style={{
                             width: '200px',
                             height: '60px',
                             display: 'flex',
                             alignItems: 'center',
                             justifyContent: 'center',
                             color: '#999',
                             backgroundColor: '#f5f5f5',
                             borderRadius: '8px',
                           }}
                         >
                           No link available
                         </div>
                       )
                     ) : credential.offer_uri ? (
                      <QRCode value={credential.offer_uri} size={200} level="M" />
                    ) : (
                      <div
                        style={{
                          width: '200px',
                          height: '200px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                        }}
                      >
                        No QR available
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="powered-by" style={{ textAlign: 'center', marginBottom: '20px' }}>
              Powered by <span style={{ color: '#007bff' }}>ditto</span>
            </div>

            <div
              style={{
                display: 'flex',
                gap: '20px',
                justifyContent: 'center',
                marginTop: '30px',
              }}
            >
              <Link to="/register" className="btn btn-secondary">
                Register Another User
              </Link>
              <button onClick={() => setAutoRedirect(true)} className="btn btn-primary" disabled={autoRedirect}>
                {autoRedirect ? 'Redirecting to Login...' : 'Continue to Login'}
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* Download Suggestions - Mobile Only */}
      {isMobile && (
        <div id="download-section" style={{ backgroundColor: '#f8f9fa', padding: '40px 0', marginTop: '40px' }}>
        <div className="container">
          <h3 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
            Recommended Wallet Apps
          </h3>
          <p style={{ textAlign: 'center', marginBottom: '30px', color: '#666' }}>
            Download one of these wallet apps to receive and manage your credentials:
          </p>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            {/* AltMe Wallet */}
            <div style={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <img 
                src="/images/altme-wallet.png" 
                alt="AltMe Wallet"
                style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '15px' }}
              />
              <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>AltMe Wallet</h4>
              <p style={{ margin: '0 0 20px 0', color: '#666', fontSize: '14px' }}>
                Secure digital identity wallet for EUDI credentials
              </p>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                {detectPlatform() === 'ios' ? (
                  <a 
                    href="https://apps.apple.com/app/id1633216869"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#007AFF',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    📱 Download for iOS
                  </a>
                ) : (
                  <a 
                    href="https://play.google.com/store/apps/details?id=co.altme.alt.me.altme"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#34A853',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    🤖 Download for Android
                  </a>
                )}
              </div>
            </div>

            {/* Talao Wallet */}
            {/* <div style={{
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '12px',
              padding: '20px',
              textAlign: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <img 
                src="/images/talao-wallet.webp" 
                alt="Talao Wallet"
                style={{ width: '60px', height: '60px', borderRadius: '12px', marginBottom: '15px' }}
              />
              <h4 style={{ margin: '0 0 10px 0', color: '#333' }}>Talao Wallet</h4>
              <p style={{ margin: '0 0 20px 0', color: '#666', fontSize: '14px' }}>
                Professional digital identity and credential management
              </p>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                {detectPlatform() === 'ios' ? (
                  <a 
                    href="https://apps.apple.com/app/id1582183266"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#007AFF',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    📱 Download for iOS
                  </a>
                ) : (
                  <a 
                    href="https://play.google.com/store/apps/details?id=co.talao.wallet"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#34A853',
                      color: 'white',
                      textDecoration: 'none',
                      borderRadius: '6px',
                      fontSize: '12px',
                      fontWeight: 'bold'
                    }}
                  >
                    🤖 Download for Android
                  </a>
                )}
              </div>
            </div> */}
          </div>
        </div>
        </div>
      )}
    </div>
  );
};

export default QRRegistrationPage;
